const ChannelComparisonBinaryDisplayOption = Object.freeze({
  BY_NETWORK_TYPE: 'BY_NETWORK_TYPE',
  PERCENT_SHARE: 'PERCENT_SHARE',
  AGGREGATE_ROWS: 'AGGREGATE_ROWS',
  HIDE_WITH_ZERO_BRAND_POSTS: 'HIDE_WITH_ZERO_BRAND_POSTS'
})
export default ChannelComparisonBinaryDisplayOption
export type ChannelComparisonBinaryDisplayOptionStrings = typeof ChannelComparisonBinaryDisplayOption[keyof typeof ChannelComparisonBinaryDisplayOption]
// RESERVE BELOW
